import React from 'react';
import { TESTIMONIALS } from '../data/coursesData';
import { Star, Quote, Sparkles } from 'lucide-react';

export default function Testimonials() {
  return (
    <section style={{ padding: '5rem 0', backgroundColor: '#050C14', color: '#FFFFFF' }}>
      <div className="container">

        {/* Section Header */}
        <div style={{ textAlign: 'center', maxWidth: '720px', margin: '0 auto 3.5rem auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            backgroundColor: 'rgba(212, 175, 55, 0.15)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#FEF08A',
            fontWeight: 700,
            fontSize: '0.82rem',
            padding: '0.35rem 0.9rem',
            borderRadius: '9999px',
            marginBottom: '0.75rem'
          }}>
            <Sparkles size={14} color="#D4AF37" /> Verified Student Feedback
          </div>
          <h2 style={{ fontSize: '2.3rem', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.02em' }}>
            Hear From Our Alumni & Learners
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#CBD5E1', marginTop: '0.5rem', lineHeight: 1.6 }}>
            Discover how working professionals transformed their careers with online degrees from Christ University.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem'
        }}>
          {TESTIMONIALS.map((testi, idx) => (
            <div key={idx} className="glass-card" style={{
              padding: '2rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
              backgroundColor: '#0F2537',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              borderRadius: '16px'
            }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <div style={{ display: 'flex', gap: '0.2rem' }}>
                    {[...Array(testi.rating)].map((_, i) => (
                      <Star key={i} size={16} fill="#D4AF37" color="#D4AF37" />
                    ))}
                  </div>
                  <Quote size={28} color="#D4AF37" style={{ opacity: 0.5 }} />
                </div>

                <p style={{ fontSize: '0.95rem', color: '#E2E8F0', lineHeight: 1.6, fontStyle: 'italic', marginBottom: '1.5rem' }}>
                  "{testi.text}"
                </p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                <img
                  src={testi.image}
                  alt={testi.name}
                  style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '1.5px solid #D4AF37' }}
                />
                <div>
                  <div style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF' }}>
                    {testi.name}
                  </div>
                  <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#34D399' }}>
                    {testi.role}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#94A3B8' }}>
                    {testi.course}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
